import { render, staticRenderFns } from "./TablesWithoutMetadataReportPage.vue?vue&type=template&id=0761d6b2&scoped=true"
import script from "./TablesWithoutMetadataReportPage.vue?vue&type=script&lang=js"
export * from "./TablesWithoutMetadataReportPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0761d6b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0761d6b2')) {
      api.createRecord('0761d6b2', component.options)
    } else {
      api.reload('0761d6b2', component.options)
    }
    module.hot.accept("./TablesWithoutMetadataReportPage.vue?vue&type=template&id=0761d6b2&scoped=true", function () {
      api.rerender('0761d6b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/audit_monitoring/TablesWithoutMetadataReportPage.vue"
export default component.exports